module.exports = __webpack_public_path__ + "img/farming_36.3c663655.png";